import { ReactNode } from "react";
import { cn } from "@/lib/utils";
import { Link } from "react-router-dom";

interface NavLinksProps {
  children: ReactNode;
  className?: string;
}

/**
 * Container for navigation links.
 * Provides consistent 32px gap spacing between nav items.
 */
export function NavLinks({
  children,
  className,
}: NavLinksProps) {
  return (
    <ul
      className={cn(
        "flex items-center gap-8",
        className
      )}
    >
      {children}
    </ul>
  );
}

interface NavLinkProps {
  href: string;
  children: ReactNode;
  className?: string;
  /** Whether this link is currently active */
  active?: boolean;
}

/**
 * Individual navigation link.
 * Handles styling for default and active states.
 */
export function NavLink({
  href,
  children,
  className,
  active,
}: NavLinkProps) {
  return (
    <li>
      <Link
        to={href}
        className={cn(
          "text-base font-normal leading-normal",
          "text-foreground hover:text-foreground/80 hover:underline",
          "transition-colors",
          active && "font-medium",
          className
        )}
      >
        {children}
      </Link>
    </li>
  );
}
